<template>
  <div class="p-grid p-fluid">
    <div class="p-col-12 p-lg-6">
      <div class="card card-w-title">
        <h1>Email confirmation success!</h1>

        <div class="p-grid p-fluid">
          <div class="p-col-4 p-md-4">
            <Button @click="login()" label="Proceed to login" />
          </div>
        </div>
        <Toast position="random" />
      </div>
    </div>
  </div>
</template>

<script>
import EmailService from "../service/EmailService.js";

export default {
  data() {
    return {
      res: null
    };
  },
  async created() {
    this.emailService = new EmailService();
    console.log("in");
    console.log(this.$route.query);
    try {
      var temp = await this.emailService.verifyEmail(this.$route.query.token);
      console.log(temp.status);
      if (!temp || temp.status !== 200) {
        console.log("reject");
        this.$router.push("reject");
      } else {
        this.res = temp;
      }
    } catch (error) {
      this.$router.push("reject");
      console.log(error);
    }
  },
  methods: {
    login() {
      var data = this.res.data.data
      this.$store.commit("logIn", {
        id: data.id,
          username: data.username,
          name: data.name,
          surname: data.surname,
          role: data.role,
          email: data.email,
          first_name: data.name,
          last_name: data.surname,
          date_of_birth: data.date_of_birth,
          phone: data.phone,
          address: data.address,
          zip: data.zip,
          city: data.city,
          country: data.country,
          account_name: data.account_name,
          account_number: data.account_number,
          account_signatory_person: data.account_signatory_person,
          swift: data.swift,
          bic: data.bic,
          iban: data.iban,
          btc_wallet: data.btc_wallet,
          bank_name: data.bank_name,
          bank_address: data.bank_address,
          bank_zip: data.bank_zip,
          bank_city: data.bank_city,
          bank_country: data.bank_country,
          token: this.res.data.token
      });
    }
  }
};
</script>

<style scoped>
</style>